import * as _ from "lodash";
import {Costbook} from "./state/costbook";

import {AppConfig} from "./app-config";

import {PopupsManager} from "./popups/popupsManager";
import {CommandsManager} from "./commandsManager";
import {ApplicationState} from "./state/applicationState";
import {ApplicationApiManager} from "./applicationApiManager";
import {ActivePanel} from "./state/activePanel";
import {EstimateRowType} from "./state/estimateRowType";
import {CommandType} from "./commandType";
import {EditorMode} from "../components/estimate-cost-row-popup/estimate-cost-row-popup";
import OidcManager from "./api/oidcManager";
import {ReportFormat} from "./state/reportFormat";
import * as ko from "knockout";
import {EstimateRow} from "./state/estimateRow";
import {CostbookRow} from "./state/costbookRow";
import {IApplicationState} from "./api/estimates";
import ShortcutsManager from "./shortcutsManager";
import {CraftCode, KeywordSearchItem} from "./api/costbooks-api";
import InstanceManager from "./instanceManager";
import AccountManager from "./accountManager";
import IntercomManager from "./intercomManager";

export class Application {

    public state = new ApplicationState();    
    
    constructor(public config: AppConfig, private oidc: OidcManager) {
        
        this.state.activePanel.subscribe((x) => {
            console.log('application: Active panel changed: ', x)
        });

        this.state.activeSidebarItem.subscribe((x) => {
            console.log('application: Sidebar item changed: ', x)
        });
        
        let estimateSelectedRowSubscription : KnockoutSubscription | undefined = undefined;
        let estimatePostalCodeSubscription : KnockoutSubscription | undefined = undefined;
        let costbookSelectedRowSubscription: KnockoutSubscription | undefined = undefined;
        let costbookTopMostRowSubscription: KnockoutSubscription | undefined = undefined;
        
        this.state.estimate.subscribe(async (val) => {
            let estimate = this.state.estimate();
            if(!estimate)
                return;

            //In this case we save state BEFORE all necessary costbooks get opened and scrolled to correct page
            //let state = this.getState();
            //console.log("STATE: ", state);
            //this.apiManager.estimate.saveState(state);

            let postalCode = this.state.estimate()!.postalCode();
            let craftCodes = await this.apiManager.costbook.searchCraftCodes({}, postalCode);
            if (craftCodes)
                this.state.estimate()!.craftCodes(craftCodes.data);
            
            if(estimateSelectedRowSubscription)
                estimateSelectedRowSubscription.dispose();
            
            estimateSelectedRowSubscription = estimate.selectedRow.subscribe(() => {
                console.log('savestate: estimateSelectedRowSubscription');
                this.saveState();
            });

            if(estimatePostalCodeSubscription)
                estimatePostalCodeSubscription.dispose();

            estimatePostalCodeSubscription = estimate.postalCode.subscribe(async () => {
                let postalCode = this.state.estimate()!.postalCode();
                let craftCodes = await this.apiManager.costbook.searchCraftCodes({}, postalCode);
                if (craftCodes)
                    this.state.estimate()!.craftCodes(craftCodes.data);
            })
            
        });

        this.state.costbook.subscribe((val) => {
            let estimate = this.state.estimate();
            if(!estimate)
                return;

            console.log('savestate: costbook.subscribe');
            this.saveState();

            if(!val)
                return;

            if (costbookSelectedRowSubscription)
                costbookSelectedRowSubscription.dispose();
            costbookSelectedRowSubscription = val.selectedRow.subscribe(() => {
                console.log('savestate: costbook.costbookSelectedRowSubscription');
                this.saveState();
            });

            if (costbookTopMostRowSubscription)
                costbookTopMostRowSubscription.dispose();
            costbookTopMostRowSubscription = val.topMostRowKey.subscribe(() => {
                console.log('savestate: costbook.costbookTopMostRowSubscription');
                this.saveState();
            })


        });
        
    }
    
    public commandsManager = new CommandsManager(this);
    public popupsManager = new PopupsManager(this);
    public apiManager = new ApplicationApiManager(this.config, this.oidc);
    public shortcutsManager = new ShortcutsManager(this);
    public instanceManager = new InstanceManager(this);
    public accountManager = new AccountManager(this);
    public intercomManager = new IntercomManager(this);

    createEstimateSubtotalRow = this.commandsManager.find(CommandType.CreateEstimateSubtotalRow);

    private getState() : IApplicationState {
        
        let estimate = this.state.estimate();
        let costbook = this.state.costbook();
        
        let costbookId : number | undefined = undefined;
        if(costbook)
            costbookId = costbook.id;
        
        let selectedRows : number[] =_.map(estimate!.selectedRow(), x => x.id);
        
        let costbooks = _.map(this.state.costbooks(), x => {
            return {
                id: x.id,
                name: x.name(),
                page: x.topMostRowKey(),// x.page(),
                selectedRows: _.map(x.selectedRow(), y => y.id),
                importDate: x.importDate()
                //topMostSectionTitle: x.name(),
                //topMostRowKey: x.topMostRowKey()
            }
        });

        console.log('GETSTATE', costbooks);

        return {
            estimateId: estimate!.id(),
            selectedRows: selectedRows,
            costBookId: costbookId,
            costbooks: costbooks
        }
    }

    public saveState() {
        if (this.state.estimate()) {
            let state = this.getState();
            this.apiManager.estimate.saveState(state);
        }
    }

    public loadEstimate(data: any){
        this.state.estimate({
            id: ko.observable(data.id),
            timestamp: ko.observable(new Date()),
            name: ko.observable(data.name),
            postalCode: ko.observable(data.postalCode),
            equipmentAreaModApplied: ko.observable(false),
            laborAreaModApplied: ko.observable(false),
            materialAreaModApplied: ko.observable(false),
            selectedRow: ko.observableArray(),
            clickedTextRow: ko.observable(undefined),
            focusedRowOrder: ko.observable(undefined),
            rows: ko.observableArray(),
            state: data.state,
            baseRow: ko.observable(null),
            number: ko.observable(undefined),
            date: ko.observable(undefined),
            jobName: ko.observable(""),
            owner: ko.observable(""),
            description: ko.observable(""),
            planDate: ko.observable(undefined),
            estimatedBy: ko.observable(""),
            checkedBy: ko.observable(""),
            completeDescription: ko.observable(""),
            pendingSelectedRowId: ko.observable(undefined),
            craftCodes: ko.observableArray()
        })
    }
        
    logOut() {
        sessionStorage.clear();
        this.oidc.logout();
    }
    
    getInsertSubmenuItems() {
        if(this.state.activePanel() != ActivePanel.Estimate)
            return [];
        
        let estimate = this.state.estimate();
        
        if(!estimate)
            return [];
        
        let data = _.last(estimate.selectedRow());
        
        if(data && data.allowedNeighbors.length == 0) {
            
            return [];
        }
       
        let result : any[] = [];

        let lines = [
            {text: "Text", type: EstimateRowType.text, above: false},
            {text: "Cost", type: EstimateRowType.cost, above: false}
        ];

        if(this.createEstimateSubtotalRow!.canExecute())
            lines.push({text: "Subtotal", type: EstimateRowType.subtotal, above: false});

        if (data && data.order === 0) {
            lines.splice(0, 0, {text: "Text", type: EstimateRowType.text, above: true}, {
                text: "Cost",
                type: EstimateRowType.cost,
                above: true
            });
        }

        lines.forEach((line) => {
            if (data && data.allowedNeighbors.indexOf(line.type) === -1) {
                return;
            }

            result.push({
                text: `Insert a ${line.text} Line${line.above ? ' before' : ''}`,
                textShort: `${line.text} Line${line.above ? ' before' : ''}`,
                execute: () => {
                    switch (line.type) {
                        case EstimateRowType.cost:
                            this.commandsManager.execute(CommandType.CreateEstimateCostRow, {
                                editorMode: EditorMode.Simple,
                                insertAbove: line.above,
                                fromCostbook: false
                            });
                            break;
                        case EstimateRowType.markup:
                            break;
                        case EstimateRowType.subtotal:
                            this.commandsManager.execute(CommandType.CreateEstimateSubtotalRow, {
                                insertAbove: line.above,
                                fromCostbook: false
                            });
                            break;
                        case EstimateRowType.tax:
                            break;
                        case EstimateRowType.text:
                            this.commandsManager.execute(CommandType.CreateEstimateTextRow, {
                                insertAbove: line.above,
                                fromCostbook: false
                            });
                            break;
                        case EstimateRowType.total:
                            break;

                    }
                }
            });
        });
        
        
        return result;
    }

    openEstimate(id: number) : JQueryPromise<void> {
        
        return this.apiManager.estimate.getEstimate(id).then((data) => {            
            let estimate = {
                id: ko.observable(data!.id),
                timestamp: ko.observable(new Date()),
                name: ko.observable(data!.name),
                postalCode: ko.observable(data!.postalCode),
                equipmentAreaModApplied: ko.observable(data!.equipmentPriceOverride),
                laborAreaModApplied: ko.observable(data!.laborPriceOverride),
                materialAreaModApplied: ko.observable(data!.materialPriceOverride),
                selectedRow: ko.observableArray<EstimateRow>(),
                clickedTextRow: ko.observable(undefined),
                focusedRowOrder: ko.observable(undefined),
                rows: ko.observableArray<EstimateRow>(),
                state: data!.state,
                baseRow: ko.observable(null),
                number: ko.observable(data!.estimateNumber),
                date: ko.observable(data!.estimateDate),
                jobName: ko.observable(data!.jobName),
                owner: ko.observable(data!.owner),
                description: ko.observable(data!.description),
                planDate: ko.observable(data!.planDate),
                estimatedBy: ko.observable(data!.estimatedBy),
                checkedBy: ko.observable(data!.checkedBy),
                completeDescription: ko.observable(data!.completeDescription),
                pendingSelectedRowId: ko.observable(undefined),
                craftCodes: ko.observableArray<CraftCode>()
            };
            
            if(data!.state) {
                if(data!.state.costbooks) {

                    let options: DevExpress.data.LoadOptions = {};
                    this.apiManager.costbook.searchCostbooks(options).then(result => {
                        if (result) {
                            let costbooks: Costbook[] = this.state.costbooks();

                            let availableBooks: any = result.data;
                            let hasChanges: boolean = false;

                            _.each(data!.state.costbooks, (x) => {
                                if (_.find(costbooks, (el: any) => el.id === x.id) === undefined &&//#324
                                    _.find(availableBooks, (el: any) => el.id === x.id) != undefined) {
                                    hasChanges = true;
                                    console.log("find costbook - ", x.id);

                                    let costbook = this.createCostbook(x);
                                    costbook.topMostRowKey(x.page);
                                    costbooks.push(costbook);
                                }
                            });

                            if (hasChanges) {
                                this.state.costbooks(costbooks);

                                if (costbooks.length == 0) {
                                    this.state.costbook(null);
                                }
                            }

                            if (data!.state.costBookId) {
                                let selectedCostbook = _.find(costbooks, (x) => x.id == data!.state.costBookId);
                                if (selectedCostbook && selectedCostbook != this.state.costbook())
                                    this.state.costbook(selectedCostbook);
                            }
                        }
                    });
                }
            }
            
            this.state.estimate(estimate);

            if(data!.history) {
                this.state.canRedo(data!.history.canRedo);
                this.state.canUndo(data!.history.canUndo);
            }
        });
    }

    createCostbook(data: any): Costbook {
        let costbook = {
            id: data.id,
            name: ko.observable(data.name),
            selectedRow: ko.observableArray<CostbookRow>(),
            page: ko.observable<number>(),
            topMostSectionTitle: ko.observable(data.name),
            topMostRowKey: ko.observable<number>(),
            totalRowCount: ko.observable(0),
            importDate: ko.observable(data.importDate),
            topMostRow: ko.observable<CostbookRow>(),
            pages: ko.observableArray<any>(),
        };

        //load content
        let loadOptions: DevExpress.data.LoadOptions = {};
        loadOptions.userData = { bookId: costbook.id };
        this.apiManager.costbook.getPages(loadOptions).then(data => {
            costbook.pages(_.sortBy(data!.data, 'index'));
        });

        return costbook;
    }
    
    async openCostbook(data : any) {
        let existingCostbook = _.find<Costbook>(this.state.costbooks(), {id: data.id});
        
        if(existingCostbook) {
            this.state.costbook(existingCostbook);
            return;
        }
        
        let costbook = this.createCostbook(data);

        if (localStorage['selectedpage_' + costbook.name()]) {
            console.log('openCostbook: localstorage', localStorage['selectedpage_' + costbook.name()]);
            costbook.topMostRowKey(localStorage['selectedpage_' + costbook.name()]);
        }else{
            if (data.firstPage) {
                await this.apiManager.costbook.getRowIndex(data.firstPage, data.id).then((index) => {
                    costbook.topMostRowKey(index!);
                });
            }
        }

        this.state.costbook(costbook);
        
        if(!_.find(this.state.costbooks(), {id: costbook.id})) {
            this.state.costbooks.push(costbook);
        }
    }
    
    closeCostbook(costbook: Costbook) {        
        this.state.costbooks.remove(costbook);

        if(this.state.costbook() == costbook) {
            if(this.state.costbooks().length > 0) {
                this.state.costbook(_.last(this.state.costbooks()));
            } else {
                this.state.costbook(undefined);
            }
        }
        this.saveState();
    }    
}




// WEBPACK FOOTER //
// ./ClientApp/services/application.ts